import * as React from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { TableButton } from "@duosoftbg/nacid-components";
import { ACADEMIC_RECOGNITION_TYPE } from "../../../../../../config/registers/common";
import SearchTable from "../../base/table/SearchTable";

const headCells = [
  {
    id: "options",
    label: "",
  },
  {
    id: "applicationNumber",
    label: "l.table.head.recordNumber",
  },
  {
    id: "applicationDate",
    label: "l.table.head.date",
  },
  {
    id: "applicantName",
    label: "l.table.head.applicant",
  },
  {
    id: "universityName",
    label: "l.table.head.foreignUniversity",
  },
  {
    id: "universityCountryName",
    label: "l.table.head.country",
  },
  {
    id: "recognizedSpecialityName",
    label: "l.table.head.recognizedSpeciality",
  },
  {
    id: "recognizedEduLevel",
    label: "l.table.head.recognizedEduLevel",
  },
  {
    id: "decisionNumber",
    label: "l.table.head.decisionNumber",
  },
  {
    id: "applicationStatus",
    label: "l.table.head.status",
  },
];

const RSearchAcademicRecognitionNacidListTable = ({
  total,
  records,
  blockTable,
  onPageOrOrderChange,
  group,
  viewURL,
}) => {
  return (
    <SearchTable
      group={group}
      headCells={headCells}
      total={total}
      blockTable={blockTable}
      onPageOrOrderChange={onPageOrOrderChange}
    >
      <TableBody>
        {records.map((row) => {
          return (
            <TableRow hover key={row.id} style={{ backgroundColor: row.applicationStatus?.id === "WEAK" && "#fff3e6" }}>
              <TableCell style={{ textAlign: "center" }}>
                <TableButton to={`${viewURL}${row.id}&type=${ACADEMIC_RECOGNITION_TYPE.NACID}`} />
              </TableCell>
              <TableCell>{row.applicationNumber}</TableCell>
              <TableCell>{row.applicationDate}</TableCell>
              <TableCell>{row.applicantName}</TableCell>
              <TableCell>{row.universityName}</TableCell>
              <TableCell>{row.universityCountryName}</TableCell>
              <TableCell>{row.recognizedSpecialityName}</TableCell>
              <TableCell>{row.recognizedEduLevel && row.recognizedEduLevel.name}</TableCell>
              <TableCell>{row.decisionNumber}</TableCell>
              <TableCell>{row.applicationStatus && row.applicationStatus.name}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </SearchTable>
  );
};

export default RSearchAcademicRecognitionNacidListTable;
